import React from 'react';
import { InspectionType, LoanPropertyFileTypeOptions, InspectionAcceptableFileTypeOptions } from '@apply/constants';
import { formatDateTime } from '@apply/ui';
import { CellRenderEvent, IInspectionFile } from '../interfaces/interfaces';

export const onDownloadClick = (e: React.MouseEvent, url: string): void => {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
};

export const onTypeRender = (e: CellRenderEvent): string => {
    switch (e.value) {
        case InspectionType.Status:
            return 'Status';
        default:
            return 'Draw';
    }
};

export const onDateRender = (e: CellRenderEvent): string | null => {
    if (!e.value) {
        return null;
    }
    return formatDateTime(e.value as string);
};

export const onPercentRender = (e: CellRenderEvent): string | null => {
    if (!e.value) {
        return null;
    }
    return e.value + '%';
};

export const onFileTypeRender = (e: CellRenderEvent): string => {
    if (e.value === null || e.value === undefined) {
        return 'Unknown';
    }
    const fileType = LoanPropertyFileTypeOptions.find((t) => t.id === e.value);
    if (!fileType) {
        return 'Unknown';
    }
    return fileType.name;
};

export const isFileExtensionSelectable = (extension: string): boolean => {
    return InspectionAcceptableFileTypeOptions.some((item) => item.extension === extension);
};

export const getExtension = (fileName: string): string => fileName.split('.').pop() ?? '';

export const getSelectableFiles = (files: IInspectionFile[]): IInspectionFile[] =>
    files.filter((file) => isFileExtensionSelectable(getExtension(file.fileName)));

export const getUnselectableFiles = (files: IInspectionFile[]): IInspectionFile[] =>
    files.filter((file) => !isFileExtensionSelectable(getExtension(file.fileName)));
